export const convertOneLineDataToCsv = (text: string, cellsCount: number): string => {
    const rows = text.split('\n');

    const result: string[][] = [];

    let list: string[] = [];

    for(let i=0; i<rows.length; i++) {
        const word = rows[i].trim();

        if (i % cellsCount === 0 && list.length > 0) {
            result.push(list);
            list = [];
        }

        list.push(word);
    }

    if (list.length > 0) {
        result.push(list);
    }

    let csv = '';

    for(const item of result) {
        csv += item.join(',') + '\n';
    }

    return csv;
};